import { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useIntl } from 'react-intl';

import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption, EuiToolTip, EuiFlexGroup } from '@elastic/eui';
import { OPTIONALS } from 'apollo-client/queries/getAvailableOptionals';
import { optionals } from 'cache';
import { Query, QueryGetAvailableOptionalsArgs } from 'generated/graphql';

import { useLocalCache } from 'hooks/useLocalCache';
import { FormattedMessage } from 'react-intl';

import * as S from './FiltersSidebar.styles';
import { SelectAll } from 'components/SelectAll';

export const OptionalFilters = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [selectAll, setSelectAll] = useState(false);

  const [onGetAvailableOptionals, { loading, data }] = useLazyQuery<Query, QueryGetAvailableOptionalsArgs>(OPTIONALS);
  const modelVersionsIsMissing = Boolean(!localFilters?.data?.modelVersions?.length);

  const DisabledOptionalFilter = (): JSX.Element => (
    <EuiToolTip
      title=""
      position="right"
      content="Per abilitare la ricerca per optional deve essere selezionato almeno un allestimento"
    >
      <EuiComboBox fullWidth isDisabled={true} placeholder={formatMessage({ id: 'filters.optionals.placeholder' })} />
    </EuiToolTip>
  );

  return (
    <S.SidebarFilterWrapper>
      <EuiFlexGroup justifyContent="spaceBetween">
        <EuiFormLabel>
          <span test-id="OptionalsFilterLabel">{formatMessage({ id: 'filters.optionals.label' })}</span>
        </EuiFormLabel>
        {selectAll && (
          <SelectAll
            onClick={(): void => {
              optionals(data?.getAvailableOptionals);
              setSelectAll(false);
            }}
          >
            <FormattedMessage id="filters.selectAll" defaultMessage="Seleziona Tutti" />
          </SelectAll>
        )}
      </EuiFlexGroup>
      {modelVersionsIsMissing ? (
        <DisabledOptionalFilter />
      ) : (
        <EuiComboBox
          async
          test-id="OptionalsFilter"
          isLoading={loading}
          placeholder={formatMessage({ id: 'filters.optionals.placeholder' })}
          options={data?.getAvailableOptionals?.map((x: string) => ({ label: x, value: x })) ?? []}
          selectedOptions={localFilters?.data?.optionals?.map((x: string) => ({ label: x, value: x }))}
          onSearchChange={(e: string): void => {
            e.length > 2 ? setSelectAll(true) : setSelectAll(false);

            onGetAvailableOptionals({
              variables: {
                inputOptional: e,
                inputModelVersions: localFilters?.data?.modelVersions?.map((x) => x.label),
              },
            });
          }}
          onClick={(): void => {
            onGetAvailableOptionals({
              variables: {
                inputOptional: '',
                inputModelVersions: localFilters?.data?.modelVersions?.map((x) => x.label),
              },
            });
          }}
          onChange={(x: EuiComboBoxOptionOption<string>[]): void => {
            optionals(x?.map(({ value }) => value) as string[]);
          }}
        />
      )}
    </S.SidebarFilterWrapper>
  );
};
